module.exports = {
    refresh: () => {
        window.location.reload();
    },
};
